import React from "react";
import Select from "react-select";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setLoading } from "@inspinia-react/actions";
import { setCityLocation } from "../actions";

import { searchCities } from "@parts/utils";
import { mapTest } from "../../../pages/products/map.test";

class CityLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      inputValue: "",
    };
    this._filter = this._filter.bind(this);
    this._onChange = this._onChange.bind(this);
  }

  _filter(inputValue) {
    const { stateLocation } = this.props;
    this.setState({ ...this, inputValue });
    if (inputValue.length > 3) {
      this.props.setLoading(true);
      const payload = (options) => {
        options.forEach((r) => {
          r.label = r.city_name;
          r.value = r.id;
        });
        this.props.setLoading(false);
        this.setState({ ...this, options });
      };
      searchCities(stateLocation.uf_code, inputValue, payload);
    }
  }
  _onChange(obj) {
    this.props.setCityLocation(obj);
  }
  UNSAFE_componentWillMount() {}

  render() {
    const { options, inputValue } = this.state;
    const { stateLocation, loading } = this.props;
    return (
      <div>
        Cidade
        <Select
          onInputChange={this._filter}
          onChange={this._onChange}
          inputValue={inputValue}
          isSearchable
          isClearable
          isDisabled={!stateLocation || loading}
          value={this.props.cityLocation}
          id= {mapTest.createClient.clientAddressCity}
          placeholder={`${
            stateLocation ? "Busque a cidade" : "Selecione o Estado primerio"
          }`}
          options={options}
        /> 
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
  stateLocation: state.stateLocation,
  cityLocation: state.cityLocation,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setCityLocation,
      setLoading,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(CityLocation);



// WEBPACK FOOTER //
// ./src/components/parts/address-component/city-location/index.jsx